// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings h2{font-size:16px}.settings .fui-Field__label{font-weight:700}", "",{"version":3,"sources":["webpack://./src/taskpane/pages/Settings.scss"],"names":[],"mappings":"AACE,aACE,cAAA,CAEF,4BACE,eAAA","sourcesContent":[".settings {\n  h2 {\n    font-size: 16px;\n  }\n  .fui-Field__label {\n    font-weight: 700;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
